import { Output } from "valibot";

import {
  CHANGE_SHOW_FLOATING_STARTER_QUESTIONS,
  CHANGE_SHOW_FLOATING_WELCOME_MESSAGE_EVENT,
  CHANGE_STARTER_QUESTIONS_EVENT,
  CHANGE_WELCOME_MESSAGE,
} from "shared/events";
import { generateUuid } from "shared/functions";
import { CommandSchema } from "shared/schemas";

import { StarterQuestionsSchema } from "../schemas";

export const fetchCommand = (
  setWidgetExpanded: (newWidgetExpanded: boolean) => void,
  command: Output<typeof CommandSchema>,
) => {
  // Starter questions
  if (command.showStarterQuestions) {
    window.dispatchEvent(
      new CustomEvent(CHANGE_SHOW_FLOATING_STARTER_QUESTIONS, {
        detail: command.showStarterQuestions,
      }),
    );
  }
  if (command.setStarterQuestions) {
    const newStarterQuestions: Output<typeof StarterQuestionsSchema> =
      command.setStarterQuestions.map(question => ({
        id: generateUuid(),
        question,
      }));
    window.dispatchEvent(
      new CustomEvent(CHANGE_STARTER_QUESTIONS_EVENT, {
        detail: newStarterQuestions,
      }),
    );
  }

  // Welcome message
  if (command.showWelcomeMessage) {
    window.dispatchEvent(
      new CustomEvent(CHANGE_SHOW_FLOATING_WELCOME_MESSAGE_EVENT, {
        detail: command.showWelcomeMessage,
      }),
    );
  }
  if (command.setWelcomeMessage) {
    window.dispatchEvent(
      new CustomEvent(CHANGE_WELCOME_MESSAGE, {
        detail: command.setWelcomeMessage,
      }),
    );
  }

  // Show widget
  if (command.widget) {
    setWidgetExpanded(command.widget === "open");
  }
};
